import './Calendar.css';
import MyAlert from '../../Components/Reusable/Alert/Alert';
// import '../../../lib/addons/dragAndDrop/styles.scss'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'
import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css'; // for DnD add-on
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../Components/Reusable/Button/CustomButton';
import { useState, useEffect, useReducer, useRef } from "react";
import { useMemo } from 'react';
import { Button, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ToastContainer} from "react-toastify";
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FilterListIcon from "@mui/icons-material/FilterList";
import dayjs from 'dayjs';
import CloseIcon from "@mui/icons-material/Close";
import { createPortal } from "react-dom";
import { InlineDateInput, InlineTimeInput, InlineDateTimeInputPro } from '../../Components/Reusable/Pickers';
import { formatMinor } from '../../Components/Reusable/CurrencyFormatter/CurrencyFormatter';
import {
  GetBarbers,
  GetServices,
  GetServiceDurations
} from '../Services/Requests';
import {
  AddAppointment,
  AddHoliday,
  EditHoliday,
  GetEvents,
  EditAppointment,
  AddCustomer,
  GetCustomers,
  UpdateAppointmentTimeSlot,
  GetConfig,
  UpdateHolidayTimeSlot,
  DeleteHoldiay,
  CancelAppointment,
  SendCommunication
} from './Requests'
import {
  notifySuccess,
  notifyError
} from '../../Response/ResposeHandler'
import Select from "react-select";
import { validEmail } from '../../Constants/RegExp';
import {DateTime } from "luxon"
import BackButton from '../../Components/Reusable/BackButton/BackButton';
function usePopover(anchorRef, isOpen, onClose) {
    const [pos, setPos] = useState({ top: 0, left: 0, placement: "bottom" });
    useEffect(() => {
    if (!isOpen) return;

    const place = () => {
      const el = anchorRef.current;
      if (!el) return;
      const r = el.getBoundingClientRect();

      // popover dimensions should match your CSS (see below)
      const popW = 360;          // desired width in px
      const popH = 380;          // approx height
      const gap = 8;             // gap below/above trigger
      const edge = 16;           // SAFETY MARGIN from viewport edges

      // Default: left-align to trigger
      let left = r.left;

      // If it would overflow right, try right-aligning to the trigger
      if (left + popW > window.innerWidth - edge) {
        left = r.right - popW;
      }
      // Clamp to viewport with edge margin
      left = Math.max(edge, Math.min(left, window.innerWidth - popW - edge));

      // Prefer bottom; flip to top if not enough room
      let placement = "bottom";
      let top = r.bottom + gap;
      if (top + popH > window.innerHeight - edge) {
        placement = "top";
        top = r.top - gap - popH;
        if (top < edge) { // still tight → push back down within margin
          placement = "bottom";
          top = Math.max(edge, r.bottom + gap);
        }
      }

      setPos({ top, left, placement });
    };

    place();
    const onScrollOrResize = () => place();
    window.addEventListener("resize", onScrollOrResize);
    window.addEventListener("scroll", onScrollOrResize, true);

    const onDoc = (e) => {
      const a = anchorRef.current;
      const inAnchor = a && a.contains(e.target);
      const inPop = (e.target instanceof Element) && e.target.closest(".pop");
      if (!inAnchor && !inPop) onClose();
    };
    const onEsc = (e) => e.key === "Escape" && onClose();

    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onEsc);
    return () => {
      window.removeEventListener("resize", onScrollOrResize);
      window.removeEventListener("scroll", onScrollOrResize, true);
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onEsc);
    };
  }, [anchorRef, isOpen, onClose]);

  return pos;
}

const localizer = momentLocalizer(moment)
const DnDCalendar = withDragAndDrop(Calendar);

  const fullDaysOfWeek = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
  ]

export default function CalendarComponent() {
  const { t, i18n } = useTranslation('calendar');
  // keep RBC (moment) in sync with the current UI language
  useEffect(() => {
    moment.locale(i18n.language || 'en');
  }, [i18n.language]);
    const [config, setConfig] = useState()
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [timeSelection, setTimeSelection] = useState([])
  const [minDateTime, setMinDateTime] = useState()
  const [calendarStep, setCalendarStep] = useState(15)
  const [maxDateTime, setMaxDateTime] = useState()
  const [showCalendar, setShowCalendar] = useState(false)
  const [barberData, setBarberData] = useState(null)
  const [resourceLanes, setResourceLanes] = useState()
  const [barberList, setBarberList] = useState([])
  const today = new Date()
  const [isEditAppointment, setIsEditAppointment] = useState(false)
  const [isSelectedDateToday, setIsSelectedDateToday] = useState(true)
  const [selectedBarber, setSelectedBarber] = useState();
  const [selectedService, setSelectedService] = useState();
  const [startDateTime, setStartDateTime] = useState();
  const [endDateTime, setEndDateTime] = useState();
  const [appointmentNotes, setAppointmentNotes] = useState('')
  const [services, setServices] = useState();
  const [duration, setDuration] = useState();
  const [customerIdToEdit, setCustomerIdToEdit] = useState();
  const [appointmentIdToEdit, setAppointmentIdToEdit] = useState();
  let customerErrorsObj = { customerFirstName: '', customerLastName: '', customerMobile: '', customerEmail: '', customerNotes: '' };
  const [customerErrors, setCustomerErrors] = useState(customerErrorsObj);
  let appointmentErrorsObj = { barber: '', service: '', date: '', duration: '', appointmentNotes: '', customer:'' };
  const [appointmentErrors, setAppointmentErrors] = useState(appointmentErrorsObj);
  let holidayErrorsObj = { holidayTitle: '', holidayBarber: '', holidayStartDate: '', holidayStartTime: '', holidayEndTime: '', holidayEndDateTime: '', holidayRecurrenceFrequency: '', holidayRecurrenceEndDate: '' };
  const [holidayErrors, setHolidayErrors] = useState(holidayErrorsObj);
  const [cancelledBy, setCancelledBy] = useState()
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [mobile, setMobile] = useState();
  const [email, setEmail] = useState('');
  const [customerNotes, setCustomerNotes] = useState('');
  const [customerBlocked, setCustomerBlocked] = useState();
  const [customerDetailsObject, setCustomerDetailsObject] = useState(null)
  const [selectedBarberForHoliday, setSelectedBarberForHoliday] = useState();
  const [startDateTimeHoliday,setStartDateTimeHoliday] = useState();
  const [startTimeHoliday,setStartTimeHoliday] = useState();
  const [startDateHoliday, setStartDateHoliday] = useState();
  const [endTimeHoliday, setEndTimeHoliday] = useState();
  const [endDateTimeHoliday,setEndDateTimeHoliday] = useState();
  const [isRecurringEvent, setIsRecurringEvent] = useState(false);
  const [isSelectedEventRecurring, setIsselectedEventRecurring] = useState(false)
  const [recurringFrequency, setRecurringFrequency] = useState("daily");
  const [endReccuranceDate, setEndRecuranceDate] = useState();
  const [holidayTitle, setHolidayTitle] = useState();
  const [eventData, setEventData] = useState();
  const [searchCustomerKeyword, setSearchCustomerKeyword] = useState()
  const [searchForCustomerError, setSearchForCustomerError] = useState()
  const [customerList, setCustomerList] = useState ([])
  const [isHolidayEdit, setIsHolidayEdit] = useState(false)
  const [holidayToEdit, setHolidayToEdit] = useState();
  const [changeHolidaySlotEvent, setChangeHolidaySlotEvent] = useState();
  const [isAppointmentCancelled, setIsAppointmentCancelled] = useState();
  const [appointmentCancelledByMessage, setAppointmentCancelledByMessage] = useState();
  const [memEvent, setMemEvent] = useState()
  const [customerAppointmentChangeMessage, setCustomerAppointmentChangeMessage] = useState()
  const [communicationType, setCommunicationType] = useState()
  const [barbersWithClash, setBarbersWithClash] = useState([])
  const [minStep, setMinStep] = useState(20)
  const [appointmentModalDisabled, setAppointmentModalDisabled] = useState(false)
  const [appointmentActionLoading, setAppointmentActionLoading] = useState(false)
  const [cancellingAppointmentLoading, setCancellingAppointmentLoading] = useState(false)
  const [paidAmount, setPaidAmount] = useState(0)
  const [refundAmount, setRefundAmount] = useState(0)
  const [dateOpen, setDateOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [saveCustomerButtonLoading, setSaveCustomerButtonLoading] = useState(false)
  const [customerSearchLoading, setCustomerSearchLoading] = useState(false)
  const [customerSaveButtonLoading, setCustomerSaveButtonLoading] = useState(false)
  const [breakButtonLoading, setBreakButtonLoading] = useState(false)
  const [breakDeleteLoading, setBreakDeleteLoading] = useState(false)
  const dateBtnRef = useRef(null);
  const filterBtnRef = useRef(null);
  useEffect(() => {
    GetConfigWrapper()
    GetServiceDurationsWrapper()
    // eslint-disable-next-line
}, []);

// --- helpers: load & set the proper dayjs locale for the current i18n language
async function loadDayjsLocale(code) {
  try {
    await import(/* webpackChunkName: "dayjs-locale-[request]" */ `dayjs/locale/${code}.js`);
    return true;
  } catch {
    return false;
  }
}

async function ensureDayjsLocaleFromI18n(i18n) {
  const raw = (i18n.resolvedLanguage || i18n.language || "en").toLowerCase();
  // try exact, underscored->hyphen, then base language
  const candidates = Array.from(
    new Set([
      raw,
      raw.replace("_", "-"),
      raw.includes("-") ? raw.split("-")[0] : raw
    ])
  );

  for (const cand of candidates) {
    if (await loadDayjsLocale(cand)) {
      dayjs.locale(cand);
      return cand;
    }
  }
  // fallback
  dayjs.locale("en");
  return "en";
}

// your existing hook
// function usePopover(anchorRef, open, onClose) { ... }

function DatePopover({ anchorRef, open, onClose, selectedDate, onPick }) {
  const pos = usePopover(anchorRef, open, onClose);
  const { t, i18n } = useTranslation();
  const [adapterLocale, setAdapterLocale] = useState(dayjs.locale() || "en");

  // Load / switch the dayjs locale whenever the popover opens or language changes
  useEffect(() => {
    if (!open) return;
    let alive = true;
    ensureDayjsLocaleFromI18n(i18n).then((lc) => {
      if (alive) setAdapterLocale(lc);
    });
    return () => {
      alive = false;
    };
  }, [open, i18n.language]);

  if (!open) return null;

  return createPortal(
    <div className={`pop pop--${pos.placement}`} style={{ top: pos.top, left: pos.left }}>
      <div className="pop__head">
        <span>{t("calendar.placeholders.selectDate")}</span>
        <button type="button" className="icon-btn" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </button>
      </div>
      <div className="pop__body">
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            value={dayjs(selectedDate)}
            onChange={(d) => {
              if (!d || !d.isValid?.()) return;
              onPick(d.toDate());
            }}
            format="DD/MM/YYYY"
            slotProps={{ toolbar: { hidden: true }, actionBar: { actions: [] } }}
          />
        </LocalizationProvider>
      </div>
    </div>,
    document.body
  );
}

function BarberPopover({ anchorRef, open, onClose, barbers, onPick, resourceLanes }) {
  const pos = usePopover(anchorRef, open, onClose);
  if (!open) return null;
  return createPortal(
    <div className={`pop pop--${pos.placement}`} style={{ top: pos.top, left: pos.left }}>
      <div className="pop__head">
        <span>{t('calendar.labels.filterBarbers')}</span>
        <button type="button" className="icon-btn" onClick={onClose}><CloseIcon fontSize="small" /></button>
      </div>
      <div className="pop__body">
        {!barbers ? (
          <p className="muted">{t('calendar.labels.loading')}</p>
        ) : (
          <div className="barber-grid">
            {barbers.map((b, idx) => {
              const unavailable = resourceLanes.filter(x => x.value === b.barberId).length !== 1;
              return (
                <button
                  key={idx}
                  type="button"
                  className={`barber-chip ${unavailable ? "is-disabled" : ""}`}
                  onClick={() => onPick(b.barberId, b.name)}
                  title={b.name}
                >
                  {b.name}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}

const initialState = false;

const reducer = (state, action) =>{
  switch (action.type){
      case 'addEventOptionsOpen':
          return { ...state, addEventOptions: true }
      case 'addEventOptionsClose':			
          return { ...state, addEventOptions: false }
      case 'AddAppointmentOpen':
          return { ...state, addAppointment: true }
      case 'AddAppointmentClose':			
          return { ...state, addAppointment: false }
      case 'addCustomerOpen':
        return { ...state, addCustomer: true }
      case 'addCustomerClose':			
        return { ...state, addCustomer: false }
      case 'addHolidayOpen':
        return { ...state, addHoliday: true }
      case 'addHolidayClose':			
        return { ...state, addHoliday: false }
      case 'editHolidayOptionsOpen':
        return { ...state, editHolidayOptions: true }
      case 'editHolidayOptionsClose':			
        return { ...state, editHolidayOptions: false }
      case 'editHolidayOptionsOnHolidayTimeSlotChangeOpen':
        return { ...state, editHolidayOptionsOnHolidayTimeSlotChange: true }
      case 'editHolidayOptionsOnHolidayTimeSlotChangeClose':			
        return { ...state, editHolidayOptionsOnHolidayTimeSlotChange: false }
      case 'deleteHolidayOptionsOpen':
        return { ...state, deleteHolidayOptions: true }
      case 'deleteHolidayOptionsClose':			
        return { ...state, deleteHolidayOptions: false }
      case 'sendCommunicationOpen':
        return { ...state, sendCommunication: true }
      case 'sendCommunicationClose':			
        return { ...state, sendCommunication: false }
      default:
      return state	
  }	
}
const [state, dispatch] = useReducer(reducer, initialState);

const ClearIndicatorStyles = (base, state) => ({
  ...base,
  cursor: "pointer",
  color: state.isFocused ? "#525252" : "#7e7e7e",
});

const ClearIndicator = (props) => {
  const {
  getStyles,
  innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
    >
        <div style={{ padding: "0px 5px" }}>{t('calendar.actions.clear')}</div>
    </div>
  );
};

function GetBarbersWrapper(servicesData, configVal) {
  setBarberData(null)
  GetBarbers().then((res) => {
    var resouceLanesArray = []
    var resouceLanesArrayV2 = []
    var barberListArray = []
    res.data.forEach(element => {
      var workingDays = []
      if (element.sunday.start !== null)
      {
        workingDays.push(1)
      }
      if (element.monday.start !== null)
      {
        workingDays.push(2)
      }
      if (element.tuesday.start !== null)
      {
        workingDays.push(3)
      }
      if (element.wednesday.start !== null)
      {
        workingDays.push(4)
      }
      if (element.thursday.start !== null)
      {
        workingDays.push(5)
      }
      if (element.friday.start !== null)
      {
        workingDays.push(6)
      }
      if (element.saturday.start !== null)
      {
        workingDays.push(7)
      }
      var obj = { value: element.barberId, label: element.name, isDisabled: element.status === 1 ? false : true, workingDayArray: workingDays, services: (element.serviceNames ?? []).map(s => s.key) }
      barberListArray.push(obj)
      var resouce = { value: element.barberId, label: element.name}
      var resourceV2 = { id: element.barberId, title: element.name }
      resouceLanesArray.push(resouce);
      resouceLanesArrayV2.push(resourceV2);
    });
      setResourceLanes(resouceLanesArray)
      setBarberList(barberListArray)
      setBarberData(res.data)
      GetEventsWrapper(res.data, new Date(), resouceLanesArray, servicesData, configVal)
  }).catch((error) => {
      notifyError(t('calendar.toasts.barbersLoadError'))
  })
}

function GetEventsWrapper(barbers, queryDate, resourceLanesData, services, configVal) {
  var starts = []
  var ends = []
  resourceLanesData.forEach((barber) => {
    const day = fullDaysOfWeek[new Date(queryDate).getDay()]
    var barberToCheck = barbers.filter(x => x.barberId === barber.value)
    var startTime = barberToCheck[0][day].start
    var endTime = barberToCheck[0][day].end
    console.log(endTime)
    if (startTime !== null && endTime !== null)
    {
      var startHour = parseInt(startTime.split(':')[0])
      var endHour = parseInt(endTime.split(':')[0])
      starts.push(startHour)
      ends.push(endHour)
    } else{

    }
  })

  var minStart = new Date(queryDate).setHours(0,0,0,0)
  var maxEnd = new Date(queryDate).setHours(23,59,0,0)
  if (starts.length > 0 && ends.length > 0) {
    console.log("yesy")
    console.log(ends)
      minStart = new Date(queryDate).setHours(Math.min.apply(0, starts),0,0,0)
      maxEnd = new Date(queryDate).setHours(Math.max.apply(0, ends),Math.max.apply(0, ends) === 23 ? 59:0,0,0)
      setMinDateTime(minStart)
      setMaxDateTime(maxEnd)
  } else {

      setMinDateTime(minStart)
      setMaxDateTime(maxEnd)
  }


  if (new Date(queryDate).setHours(0,0,0,0) === new Date(today).setHours(0,0,0,0)) {
    setIsSelectedDateToday(true)
  } else {
    setIsSelectedDateToday(false)
  }
  setSelectedDate(queryDate);

  //setting calendar blocks
  var eventss = []
  barbers.forEach((barber, index) => {
    const day = fullDaysOfWeek[new Date(queryDate).getDay()]
    var startTime = barber[day].start
    const endTime = barber[day].end
    var eventt = {}
    if (startTime !== null && endTime !== null)
    {
      if (parseInt(startTime.split(':')[0]) !== Math.min.apply(0, starts))
      {
        eventt = {
          id : index,
          eventId: index,
          eventType: 'CalendarBlockOut',
          title: '5',
          start: new Date(new Date(queryDate).setHours(0,0,0,0)),
          end: new Date(new Date(queryDate).setHours(parseInt(startTime.split(':')[0]),0,0,0)),
          resourceId: barber.barberId,
          isCalanderBlock: true,
          isResizable: false,
          isDraggable: false,
          colorEvento: '#dedede'
        }
        eventss.push(eventt)
      }
      if (parseInt(endTime.split(':')[0]) !== Math.max.apply(0, ends))
      {
        eventt = {
          id : index,
          eventId: index,
          eventType: 'CalendarBlockOut',
          title: '',
          start:new Date(new Date(queryDate).setHours(parseInt(endTime.split(':')[0]),0,0,0)), 
          end: new Date(new Date(queryDate).setHours(23,59,0,0)),
          resourceId: barber.barberId,
          isCalanderBlock: true,
          isResizable: false,
          isDraggable: false,
          colorEvento: '#dedede'
        }
        eventss.push(eventt)
      }

    } else {
      eventt = {
        id : index,
        eventId: index,
        eventType: 'CalendarBlockOut',
        title: 'null',
        start: new Date(new Date(queryDate).setHours(0,0,0,0)),
        end: new Date(new Date(queryDate).setHours(23,59,0,0)),
        resourceId: barber.barberId,
        isCalanderBlock: true,
        isResizable: false,
        isDraggable: false,
        colorEvento: '#dedede'
      }
      eventss.push(eventt)
    }

  })

  //getting events from DB and setting them as calendar events
  GetEvents(queryDate).then((res) => {
    res.data.forEach((event) => {
      console.log(barbers.filter(x => x.barberId === event.barberId)[0])
      var color = barbers.filter(x => x.barberId === event.barberId)[0].barberColour
      var eventt = {
        id : event.eventId,
        eventId: event.eventId,
        allDay:false,
        // fullDay: t,
        eventType: event.eventType,
        title: event.cancelled ? t('calendar.labels.cancelled_label') : event.eventType === 3 ? event.recurringFrequency === null ? event.title : String.fromCodePoint(8620) + ' ' + event.title : event.eventType === 2 ? event.title : event.eventType === 4 ? event.title : ((event.isFirstAppointment ? String.fromCodePoint(9733) + ' ' : '') + (event.appointmentNotes !== "" | event.customerNotes !== "" ? String.fromCodePoint(9998) + " " : "" )) + event.firstName + ' - ' + services.filter(x => x.value === event.serviceId)[0].label,
        serviceId: event.serviceId,
        appointmentNotes: event.appointmentNotes,
        isFirstAppointment: event.isFirstAppointment,
        paidAmount: event.paidAmount,
        cancelled: event.cancelled,
        cancelledBy: event.cancelledBy,
        cancelledAtUtc: new Date(DateTime.fromISO(event.cancelledAtUtc, {zone: "utc"}).setZone(configVal.timeZone).toString().split("+")[0]),
        // cancelledAtUtc: new Date(DateTime.fromISO(event.cancelledAtUtc, {zone: 'utc'}).setZone(configVal.timeZone)),
        // cancelledAtUtc: new Date(event.cancelledAtUtc),
        customerId: event.customerId,
        firstName: event.firstName,
        lastName: event.lastName,
        phoneNumber: event.phoneNumber,
        createdBy: event.createdBy,
        email: event.email,
        customerNotes: event.customerNotes,
        customerBlocked: event.blocked,
        refundAmount:event.refundAmount,
        // start: startutcDt,
        // end: qatend,
        start: new Date(DateTime.fromISO(event.startDateTime, {zone: "utc"}).setZone(configVal.timeZone).toString().split("+")[0]),
        end: new Date(DateTime.fromISO(event.endDateTime, {zone: "utc"}).setZone(configVal.timeZone).toString().split("+")[0]),
        // start: new Date(DateTime.fromISO(event.startDateTime, {zone: 'utc'}).setZone(configVal.timeZone)),
        // end: new Date(DateTime.fromISO(event.endDateTime, {zone: 'utc'}).setZone(configVal.timeZone)),
        // end: DateTime.fromISO("2025-07-20T11:40:00Z", {zone: 'utc'}).setZone("Europe/London"),
        // start: new Date(event.startDateTime),
        // end: new Date(event.endDateTime),
        recurrenceStartDate: event.recurrenceStartDate,
        recurringFrequency: event.recurringFrequency,
        endReccurrenceDate: event.endReccurrenceDate,
        // recurrenceStartDate: new Date(DateTime.fromISO(event.recurrenceStartDate, {zone: 'utc'}).setZone("Europe/"+configVal.timeZone)),
        // endReccurrenceDate: new Date(DateTime.fromISO(event.endReccurrenceDate, {zone: 'utc'}).setZone("Europe/"+configVal.timeZone)),
        resourceId: event.barberId,
        isCalanderBlock: false,
        isResizable: true,
        isDraggable: !event.cancelled && event.eventType !==4,
        // colorEvento: color
        colorEvento: event.cancelled === true ? 'rgba(190, 190, 190, 0.5)' : event.eventType === 1 ? color : event.eventType === 2 ?  configVal.calendarBreakColour : event.eventType === 3 ? configVal.calendarBreakColour : event.eventType = 4 ? '#fff0f0ff' : 'grey'
      }

      eventss.push(eventt)
    })
    setEventData(eventss)
  }).catch((error) => {
    notifyError(t('calendar.toasts.eventsLoadError'))
    console.log(error)
  }).finally((f) => {
    hasOverlap(eventss.filter(x => x.eventType === 1), barbers);
  })

  }

  function GetServiceDurationsWrapper() {
    GetServiceDurations().then((res) => {
      setTimeSelection(res.data)
    }).catch((error) => {
      notifyError(t('calendar.toasts.serviceDurationsLoadError'))
    })
  }

function GetConfigWrapper() {
  var configVal = ""
    GetConfig().then((res) => {
      configVal = res.data
      setConfig(res.data)
      if (res.data.durationBlock === 1)
      {
        setCalendarStep(10);
        setMinStep(10)
      }

      if (res.data.durationBlock === 2){
        setCalendarStep(15);
        setMinStep(15)
      }

      if (res.data.durationBlock === 3){
        setCalendarStep(20);
        setMinStep(20)
      }
    }).catch((error) => {
      notifyError(t('calendar.toasts.configLoadError'))
    }).finally(() => {
      GetServicesWrapper(configVal)
    })
  }

function GetServicesWrapper(configVal) {
  GetServices().then((res) => {
      var tempVar = []
      // eslint-disable-next-line
      res.data.map((item, index) => {
          var obj = { value: item.serviceId, label: item.name, duration: item.duration, price:item.price, acceptOnlinePayment: item.acceptOnlinePayment, isDisabled: item.status === 1 ? false : true }
          tempVar.push(obj)
      })
      setServices(tempVar)
      GetBarbersWrapper(tempVar, configVal)
  }).catch((error) => {
      notifyError(t('calendar.toasts.servicesLoadError'))
  })
  }

  const { views } = useMemo(
    () => ({
      defaultDate: new Date(),
      views: ['day', 'work_week'],
      scrollToTime: moment().add(4, 'hours').toDate()
    }),
    []
  )
  
// assumes: const { t } = useTranslation('calendar');

const onEventDrop = (e) => {
  setMemEvent(e.event)
  setCommunicationType('appointment changed')
  var tempEvents = eventData.filter(item => item.id !== e.event.id)
  setEventData(tempEvents)
  //instead of removing the event, the event start and end time can be updated locally
  if (
    (e.start.getTime() === e.event.start.getTime() &&
     e.end.getTime() === e.event.end.getTime() &&
     e.resourceId === e.event.resourceId) ||
    (new Date() > new Date(e.start))
  ) {
  } else {
    const calanderBlockOuts = eventData.filter(x => x.eventType === "CalendarBlockOut" && x.resourceId === e.resourceId)
    const clashWithCalanderBlockOuts = eventClashChecker(calanderBlockOuts, e.start, e.end)
    const leaveHolidays = eventData.filter(x => x.eventType === 4 && x.resourceId === e.resourceId)
    const clashWithLeave = eventClashChecker(leaveHolidays, e.start, e.end)

    if (clashWithCalanderBlockOuts.length === 0 && clashWithLeave.length === 0) {
      if (e.event.eventType === 1) {
        const calanderAppointmentsForBarber = eventData.filter(
          x => x.eventType === 1 && x.resourceId === e.resourceId && x.eventId !== e.event.eventId && !x.cancelled
        )
        const clashedEvents = eventClashChecker(calanderAppointmentsForBarber, new Date(e.start), new Date(e.end))
        if (clashedEvents.length > 0){
          MyAlert.fire({
            icon: 'error',
            title: t('calendar.alerts.appointmentClashTitle'),
            html: `${t('calendar.alerts.clashIntro')} <b>` +
              clashedEvents.map((clashedEvent) => {
                return '<br/>' + clashedEvent.title + '&nbsp &nbsp' +
                  ("0" + new Date(clashedEvent.start).getHours()).slice(-2) + ':' +
                  ("0" + new Date(clashedEvent.start).getMinutes()).slice(-2) + ' - ' +
                  ("0" + new Date(clashedEvent.end).getHours()).slice(-2) + ':' +
                  ("0" + new Date(clashedEvent.end).getMinutes()).slice(-2)
              })
          })
        } else {
          const calanderHolidaysForBarber = eventData.filter(x => (x.eventType === 2 || x.eventType === 3) && x.resourceId === e.resourceId)
          const clashedWithHolidays = eventClashChecker(calanderHolidaysForBarber, new Date(e.start), new Date(e.end))
          if (clashedWithHolidays.length > 0){
            MyAlert.fire({
              title: t('calendar.alerts.moveAppointment'),
              text: t('calendar.alerts.breakDuringAppointment'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: 'var(--primary)',
              cancelButtonColor: '#aaa',
              confirmButtonText: t('calendar.actions.yes')
            }).then((result) => {
              if (result.isConfirmed) {
                UpdateAppointmentTimeSlot(
                  e.event.eventId,
                  e.resourceId,
                  e.start,
                  e.end,
                ).then(() => {
                  notifySuccess(t('calendar.toasts.appointmentMoved'))
                  dispatch({type:'AddAppointmentClose'})
                  GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
                  resetAppointmentModal()
                  OpenSendCommunicationModal("appointment changed")
                }).catch(() => {
                  notifyError(t('calendar.toasts.unableMoveAppointment'))
                }).finally(() => {})
              }
            })
          } else {
            UpdateAppointmentTimeSlot(
              e.event.eventId,
              e.resourceId,
              e.start,
              e.end,
            ).then(() => {
              notifySuccess(t('calendar.toasts.appointmentMoved'))
              dispatch({type:'AddAppointmentClose'})
              GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
              resetAppointmentModal()
              OpenSendCommunicationModal("appointment changed")
            }).catch(() => {
              notifyError(t('calendar.toasts.unableMoveAppointment'))
            }).finally(() => {})
          }
        }
        GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
      }

      if (e.event.eventType === 3 && e.resourceId === e.event.resourceId) {
        const barbersEvents = eventData.filter(x => x.eventType === 1 && x.resourceId === e.event.resourceId && !x.cancelled)
        const clashWithAppointments = eventClashChecker(barbersEvents, e.start, e.end)
        if (clashWithAppointments.length > 0) {
          MyAlert.fire({
            title: t('calendar.alerts.changeBreak'),
            text: t('calendar.alerts.appointmentsDuringBreak'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'var(--primary)',
            cancelButtonColor: '#aaa',
            confirmButtonText: t('calendar.actions.changeBreak')
          }).then((result) => {
            if (result.isConfirmed) {
              setChangeHolidaySlotEvent(e)
              dispatch({type:'editHolidayOptionsOnHolidayTimeSlotChangeOpen'})
            }
          })
        } else {
          setChangeHolidaySlotEvent(e)
          dispatch({type:'editHolidayOptionsOnHolidayTimeSlotChangeOpen'})
        }
      }

      if (e.event.eventType === 2 && e.resourceId === e.event.resourceId) {
        const barbersEvents = eventData.filter(x => x.eventType === 1 && x.resourceId === e.event.resourceId && !x.cancelled)
        const clashWithAppointments = eventClashChecker(barbersEvents, e.start, e.end)
        if (clashWithAppointments.length > 0) {
          MyAlert.fire({
            title: t('calendar.alerts.changeBreak'),
            text: t('calendar.alerts.appointmentsDuringBreak'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'var(--primary)',
            cancelButtonColor: '#aaa',
            confirmButtonText: t('calendar.actions.changeBreak')
          }).then((result) => {
            if (result.isConfirmed) {
              changeHolidaySlot(4, e)
            }
          })
        } else {
          changeHolidaySlot(4, e)
        }
        GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
      }
    }
  }
  GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
};

function OpenSendCommunicationModal(communicationType){
  if (communicationType === "appointment changed") {
    setCustomerAppointmentChangeMessage(config.appointmentChangedMessageToCustomer)
  }
  if (communicationType ===  "appointment cancelled") {
    setCustomerAppointmentChangeMessage(config.appointmentCancellationMessageToCustomer)
  }
  dispatch({type:'sendCommunicationOpen'})
}

function onSubmitSendCommunicationClick(e) {
  e.preventDefault()
  setCustomerSaveButtonLoading(true)
  SendCommunication(
    communicationType,
    memEvent.id,
    customerAppointmentChangeMessage
  ).then(() => {
    notifySuccess(t('calendar.toasts.emailSent'))
    dispatch({type:'sendCommunicationClose'})
    setCommunicationType()
    setMemEvent()
  }).catch(() => {
    notifyError(t('calendar.toasts.emailSendError'))
  }).finally(() => {
    setCustomerSaveButtonLoading(false)
  })
}

const changeHolidaySlot = (option, e = null) => {
  if (e === null) {
    UpdateHolidayTimeSlot(
      changeHolidaySlotEvent.event.eventId,
      changeHolidaySlotEvent.resourceId,
      changeHolidaySlotEvent.start,
      changeHolidaySlotEvent.end,
      option
    ).then(() => {
      notifySuccess(t('calendar.toasts.breakMoved'))
      dispatch({type:'editHolidayOptionsOnHolidayTimeSlotChangeClose'})
      GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
      resetHolidaysModal()
    }).catch(() => {
      notifyError(t('calendar.toasts.unableMoveBreak'))
    }).finally(() => {})
  } else {
    UpdateHolidayTimeSlot(
      e.event.eventId,
      e.resourceId,
      e.start,
      e.end,
      option
    ).then(() => {
      notifySuccess(t('calendar.toasts.breakMoved'))
      dispatch({type:'editHolidayOptionsOnHolidayTimeSlotChangeClose'})
      GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
      resetHolidaysModal()
    }).catch(() => {
      notifyError(t('calendar.toasts.unableMoveBreak'))
    }).finally(() => {})
  }
}

const onEventResize = (e) => {
  setMemEvent(e.event)
  setCommunicationType('appointment changed')
  if (new Date(e.start).getTime() !== new Date(e.end).getTime()){
    if (
      (e.start.getTime() === e.event.start.getTime() &&
       e.end.getTime() === e.event.end.getTime() &&
       e.resourceId === e.event.resourceId) ||
      (new Date() > new Date(e.start))
    ) {
    } else {
      const calanderBlockOuts = eventData.filter(x => x.eventType === "CalendarBlockOut" && x.resourceId === e.resourceId)
      const clashWithCalanderBlockOuts = eventClashChecker(calanderBlockOuts, e.start, e.end)
      if (clashWithCalanderBlockOuts.length === 0) {
        if (e.event.eventType === 1) {
          const calanderAppointmentsForBarber = eventData.filter(
            x => x.eventType === 1 && x.resourceId === e.resourceId && x.eventId !== e.event.eventId && !x.cancelled
          )
          const clashedEvents = eventClashChecker(calanderAppointmentsForBarber, new Date(e.start), new Date(e.end))
          if (clashedEvents.length > 0){
            MyAlert.fire({
              icon: 'error',
              title: t('calendar.alerts.appointmentClashTitle'),
              html: `${t('calendar.alerts.clashIntro')} <b>` +
                clashedEvents.map((clashedEvent) => {
                  return '<br/>' + clashedEvent.title + '&nbsp &nbsp' +
                    ("0" + new Date(clashedEvent.start).getHours()).slice(-2) + ':' +
                    ("0" + new Date(clashedEvent.start).getMinutes()).slice(-2) + ' - ' +
                    ("0" + new Date(clashedEvent.end).getHours()).slice(-2) + ':' +
                    ("0" + new Date(clashedEvent.end).getMinutes()).slice(-2)
                })
            })
          } else {
            const calanderHolidaysForBarber = eventData.filter(x => (x.eventType === 2 || x.eventType === 3) && x.resourceId === e.resourceId)
            const clashedWithHolidays = eventClashChecker(calanderHolidaysForBarber, new Date(e.start), new Date(e.end))
            if (clashedWithHolidays.length > 0){
              MyAlert.fire({
                title: t('calendar.alerts.changeAppointment'),
                text: t('calendar.alerts.breakDuringAppointment'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'var(--primary)',
                cancelButtonColor: '#aaa',
                confirmButtonText: t('calendar.actions.changeBreak')
              }).then((result) => {
                if (result.isConfirmed) {
                  UpdateAppointmentTimeSlot(
                    e.event.eventId,
                    e.resourceId,
                    e.start,
                    e.end,
                  ).then(() => {
                    notifySuccess(t('calendar.toasts.appointmentMoved'))
                    dispatch({type:'AddAppointmentClose'})
                    GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
                    resetAppointmentModal()
                    OpenSendCommunicationModal("appointment changed")
                  }).catch(() => {
                    notifyError(t('calendar.toasts.unableMoveAppointment'))
                  }).finally(() => {})
                }
              })
            } else {
              UpdateAppointmentTimeSlot(
                e.event.eventId,
                e.resourceId,
                e.start,
                e.end,
              ).then(() => {
                notifySuccess(t('calendar.toasts.appointmentMoved'))
                dispatch({type:'AddAppointmentClose'})
                GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
                resetAppointmentModal()
                OpenSendCommunicationModal("appointment changed")
              }).catch(() => {
                notifyError(t('calendar.toasts.unableMoveAppointment'))
              }).finally(() => {})
            }
          }
        }

        if (e.event.eventType === 3) {
          const barbersEvents = eventData.filter(x => x.eventType === 1 && x.resourceId === e.event.resourceId && !x.cancelled)
          const clashWithAppointments = eventClashChecker(barbersEvents, e.start, e.end)
          if (clashWithAppointments.length > 0) {
            MyAlert.fire({
              title: t('calendar.alerts.changeBreak'),
              text: t('calendar.alerts.appointmentsDuringBreak'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: 'var(--primary)',
              cancelButtonColor: '#aaa',
              confirmButtonText: t('calendar.actions.changeBreak')
            }).then((result) => {
              if (result.isConfirmed) {
                setChangeHolidaySlotEvent(e)
                dispatch({type:'editHolidayOptionsOnHolidayTimeSlotChangeOpen'})
              }
            })
          } else {
            setChangeHolidaySlotEvent(e)
            dispatch({type:'editHolidayOptionsOnHolidayTimeSlotChangeOpen'})
          }
        }

        if (e.event.eventType === 2) {
          const barbersEvents = eventData.filter(x => x.eventType === 1 && x.resourceId === e.event.resourceId && !x.cancelled)
          const clashWithAppointments = eventClashChecker(barbersEvents, e.start, e.end)
          if (clashWithAppointments.length > 0) {
            MyAlert.fire({
              title: t('calendar.alerts.changeBreak'),
              text: t('calendar.alerts.appointmentsDuringBreak'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: 'var(--primary)',
              cancelButtonColor: '#aaa',
              confirmButtonText: t('calendar.actions.changeBreak')
            }).then((result) => {
              if (result.isConfirmed) {
                changeHolidaySlot(4, e)
              }
            })
          } else {
            changeHolidaySlot(4, e)
          }
        }
      }
    }
  }
}



function addDuration(duration) {
  setDuration(duration)
  if (startDateTime !== undefined && startDateTime !== null) {
    const endDateTimeValue = new Date(startDateTime)
    let mins = 0
    if (config.durationBlock === 1) mins = duration.value * 10
    if (config.durationBlock === 2) mins = duration.value * 15
    if (config.durationBlock === 3) mins = duration.value * 20
    endDateTimeValue.setMinutes(endDateTimeValue.getMinutes() + mins)
    setEndDateTime(endDateTimeValue)
  }
}

function startDateHandler(e) {
  setStartDateTime(new Date(e))
  if (duration !== undefined) {
    const endDateTimeValue = new Date(e)
    let mins = 0
    if (config.durationBlock === 1) mins = duration.value * 10
    if (config.durationBlock === 2) mins = duration.value * 15
    if (config.durationBlock === 3) mins = duration.value * 20
    endDateTimeValue.setMinutes(endDateTimeValue.getMinutes() + mins)
    setEndDateTime(endDateTimeValue)
  }
}

function onClickBarberName(id, name) {
  const check = resourceLanes.filter(x => x.value === id)
  if (check.length === 1) {
    const temp = resourceLanes.filter(x => x.value !== id)
    setResourceLanes(temp)
  } else {
    const tempp = { value: id, label: name }
    const newResourceLane = [...resourceLanes, tempp]
    setResourceLanes(newResourceLane)
  }
}

function selectServiceHandler(e) {
  setSelectedService({ value: e.value, label: e.label })
  setDuration(timeSelection.filter(x => x.value === e.duration)[0])
  addDuration(timeSelection.filter(x => x.value === e.duration)[0])
}

function hasOverlap(events, barbers) {
  setBarbersWithClash([])
  const barberIds = []
  if (events.lenth !== 0) {
    barbers.forEach(barber => {
      const barberFilteredEvent = events.filter(x => x.resourceId === barber.barberId && x.cancelled === false)
      const sorted = barberFilteredEvent.slice().sort((a, b) => new Date(a.start) - new Date(b.start))
      for (let i = 0; i < sorted.length - 1; i++) {
        const currentEnd = new Date(sorted[i].end)
        const nextStart = new Date(sorted[i + 1].start)
        if (currentEnd > nextStart) {
          barberIds.push(sorted[i].resourceId)
          break
        }
      }
    })
    setBarbersWithClash(barbers.filter(x => barberIds.includes(x.barberId)).map(a => a.name))
  }
  setShowCalendar(true)
}

function eventClashChecker(eventsToCheck, startDate, endDate) {
  const clashedEvents = []
  eventsToCheck.forEach((elem) => {
    const test = !((moment(endDate).diff(moment(elem.start))) <= 0 ||
      (moment(startDate).diff(moment(elem.end))) >= 0)
    if (test) clashedEvents.push(elem)
  })
  return clashedEvents
}

function onSelectSlot(e) {
  const calanderBlockOuts = eventData.filter(x => x.eventType === "CalendarBlockOut" && x.resourceId === e.resourceId)
  const clashWithCalanderBlockOuts = eventClashChecker(calanderBlockOuts, e.start, e.end)
  if (clashWithCalanderBlockOuts.length === 0) {
    if (clashWithCalanderBlockOuts.length > 0) {
      MyAlert.fire({
        title: t('calendar.alerts.addBreak'),
        text: t('calendar.alerts.appointmentsDuringBreak'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'var(--primary)',
        cancelButtonColor: '#aaa',
        confirmButtonText: t('calendar.actions.createBreak')
      }).then((result) => {
        if (result.isConfirmed) {
          resetHolidaysModal()
          setStartDateHoliday(dayjs(e.start))
          setStartTimeHoliday(e.start)
          setEndTimeHoliday(dayjs(e.end))
          setStartDateTimeHoliday(dayjs(e.start))
          setStartDateHoliday(dayjs(e.start))
          setSelectedBarberForHoliday(barberList.filter(x => x.value === e.resourceId))
          setIsHolidayEdit(false)
          dispatch({ type: 'addHolidayOpen' })
        }
      })
    } else {
      setMemEvent(e)
      dispatch({ type: 'addEventOptionsOpen' })
    }
  }
}

function CreateAppointmentOption(e) {
  e.preventDefault()
  if (memEvent === undefined) {
    dispatch({ type: 'addEventOptionsClose' })
    dispatch({ type: 'AddAppointmentOpen' })
    setIsAppointmentCancelled(false)
    setIsEditAppointment(false)
  } else {
    resetAppointmentModal()
    setCommunicationType()
    setSelectedBarber(barberList.filter(x => x.value === memEvent.resourceId)[0])
    setStartDateTime(dayjs(memEvent.start))
    dispatch({ type: 'addEventOptionsClose' })
    dispatch({ type: 'AddAppointmentOpen' })
  }
}

function CreateHolidayOption(e) {
  e.preventDefault()
  if (memEvent === undefined) {
    dispatch({ type: 'addEventOptionsClose' })
    dispatch({ type: 'addHolidayOpen' })
    setIsHolidayEdit(false)
  } else {
    resetHolidaysModal()
    setStartDateHoliday(dayjs(memEvent.start))
    setStartTimeHoliday(dayjs(memEvent.start))
    setEndTimeHoliday(dayjs(memEvent.end))
    setStartDateTimeHoliday(dayjs(memEvent.start))
    setEndDateTimeHoliday(dayjs(memEvent.end))
    setSelectedBarberForHoliday(barberList.filter(x => x.value === memEvent.resourceId)[0])
    setIsHolidayEdit(false)
    dispatch({ type: 'addEventOptionsClose' })
    dispatch({ type: 'addHolidayOpen' })
  }
}

function onSelectEvent(e) {
  if (e.eventType === 1) {
    setMemEvent(e)
    setPaidAmount(e.paidAmount)
    setRefundAmount(e.refundAmount === null ? 0 : e.refundAmount)
    setIsAppointmentCancelled(e.cancelled)
    setAppointmentCancelledByMessage(
      e.cancelled
        ? (e.cancelledBy === "Shop" ? t('calendar.labels.cancelled.shop') : t('calendar.labels.cancelled.customer')) +
          ' ' + new Date(e.cancelledAtUtc).toLocaleDateString(i18n.language || "en") +
          ' ' + t('calendar.labels.at') + ' ' +
          new Date(e.cancelledAtUtc).toLocaleTimeString(i18n.language || "en")
        : null
    )
    setIsEditAppointment(true)
    setSelectedBarber(barberList.filter(x => x.value === e.resourceId)[0])
    setSelectedService(services.filter(x => x.value === e.serviceId)[0])
    setStartDateTime(dayjs(e.start))
    setEndDateTime(dayjs(e.end))
    setDuration(
      timeSelection.filter(
        x => x.value === ((new Date(e.end).getTime() - new Date(e.start).getTime()) / 60000) /
          (config.durationBlock === 1 ? 10 : (config.durationBlock === 2 ? 15 : 20))
      )[0]
    )
    setAppointmentNotes(e.appointmentNotes)
    setFirstName(e.firstName)
    setCancelledBy(e.cancelledBy)
    setLastName(e.lastName)
    setMobile(e.phoneNumber)
    setEmail(e.email)
    setCustomerNotes(e.customerNotes)
    setCustomerBlocked(e.customerBlocked)
    const newCustomerObject = {
      firstName: e.firstName,
      lastName: e.lastName,
      mobile: e.phoneNumber,
      email: e.email,
      notes: e.customerNotes,
      isBlocked: e.customerBlocked
    }
    setCustomerDetailsObject(newCustomerObject)
    setCustomerIdToEdit(e.customerId)
    setAppointmentIdToEdit(e.eventId)
    if (new Date() > new Date(e.end)) {
      setAppointmentModalDisabled(true)
    } else {
      setAppointmentModalDisabled(false)
    }
    dispatch({ type: 'AddAppointmentOpen' })
  }

  if (e.eventType === 2 || e.eventType === 3) {
    setIsHolidayEdit(true)
    setHolidayToEdit(e.eventId)
    setHolidayTitle(e.recurringFrequency !== null ? e.title.replace(/^[^\w]+/, "") : e.title)
    setSelectedBarberForHoliday(barberList.filter(x => x.value === e.resourceId)[0])
    setStartDateTimeHoliday(dayjs(e.start))
    setEndDateTimeHoliday(dayjs(e.end))
    setStartDateHoliday(dayjs(e.start))
    setStartTimeHoliday(dayjs(e.start))
    setEndTimeHoliday(dayjs(e.end))
    setIsRecurringEvent(e.recurringFrequency !== null ? true : false)
    setIsselectedEventRecurring(e.recurringFrequency !== null ? true : false)
    setRecurringFrequency(e.recurringFrequency)
    setEndRecuranceDate(e.endReccuranceDate === null ? undefined : dayjs(e.endReccurrenceDate))
    dispatch({ type: 'addHolidayOpen' })
  }
}

function onDeleteHoliday(deleteOption) {
  MyAlert.fire({
    title: t('calendar.alerts.deleteBreak'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: 'var(--primary)',
    cancelButtonColor: '#aaa',
    confirmButtonText: t('calendar.actions.delete')
  }).then((result) => {
    if (result.isConfirmed) {
      setBreakDeleteLoading(true)
      DeleteHoldiay(
        holidayToEdit,
        eventData.filter(x => x.eventId === holidayToEdit)[0].start,
        deleteOption,
      ).then((res) => {
        notifySuccess(t('calendar.toasts.breakDeleted'))
        dispatch({ type: 'deleteHolidayOptionsClose' })
        dispatch({ type: 'addHolidayClose' })
        GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
      }).catch((error) => {
        notifyError(t('calendar.toasts.unableDeleteBreak'))
      }).finally((f) => {
        resetHolidaysModal()
        setBreakDeleteLoading(false)
      })
    }
  })
}

function onCancelAppointment(cancelAppointmentOption) {
  MyAlert.fire({
    title: cancelAppointmentOption === 0
      ? t('calendar.alerts.cancelAppointmentConfirm')
      : t('calendar.alerts.reinstateAppointmentConfirm'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: 'var(--primary)',
    cancelButtonColor: '#aaa',
    confirmButtonText: t('calendar.actions.yes'),
    cancelButtonText: t('calendar.actions.no')
  }).then((result) => {
    if (result.isConfirmed) {
      setCancellingAppointmentLoading(true)
      const cancelAppointmentBy = "Shop"
      CancelAppointment(
        appointmentIdToEdit,
        cancelAppointmentOption,
        cancelAppointmentBy
      ).then((res) => {
        notifySuccess(t('calendar.toasts.appointmentCancelled'))
        dispatch({ type: 'AddAppointmentClose' })
        if (cancelAppointmentOption === 0) {
          setCommunicationType("appointment cancelled")
          OpenSendCommunicationModal("appointment cancelled")
        }
      }).catch((error) => {
        notifyError(t('calendar.toasts.unableCancelAppointment'))
      }).finally((f) => {
        GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
        resetAppointmentModal()
        setCancellingAppointmentLoading(false)
      })
    }
  })
}

function resetCustomerModal() {
  setSearchCustomerKeyword()
  setCancelledBy()
  setFirstName('')
  setLastName('')
  setMobile()
  setEmail('')
  setCustomerNotes('')
  setCustomerErrors(customerErrorsObj)
  setCustomerBlocked()
  setSearchForCustomerError()
  setCustomerList([])
}

function resetAppointmentModal() {
  resetCustomerModal()
  setSelectedBarber()
  setSelectedService()
  setPaidAmount(0)
  setRefundAmount(0)
  setStartDateTime()
  setEndDateTime()
  setDuration()
  setAppointmentNotes('')
  setAppointmentErrors(appointmentErrorsObj)
  setCustomerDetailsObject(null)
  setAppointmentModalDisabled(false)
  setIsAppointmentCancelled()
  setAppointmentCancelledByMessage()
  setIsEditAppointment(false)
}

function resetHolidaysModal() {
  setHolidayTitle()
  setSelectedBarberForHoliday()
  setStartDateTimeHoliday()
  setEndDateTimeHoliday()
  setIsRecurringEvent(false)
  setRecurringFrequency("daily")
  setEndRecuranceDate()
  setStartDateHoliday()
  setStartTimeHoliday()
  setEndTimeHoliday()
  setHolidayErrors(holidayErrorsObj)
  setMemEvent()
}

function loadCustomerDetails() {
  setFirstName(customerDetailsObject.firstName)
  setLastName(customerDetailsObject.lastName)
  setEmail(customerDetailsObject.email)
  setMobile(customerDetailsObject.mobile)
  setCustomerNotes(customerDetailsObject.notes)
  setCustomerBlocked(customerDetailsObject.isBlocked)
  setCustomerErrors(customerErrorsObj)
}

function OnCustomerSubmitClick(e) {
  e.preventDefault();
  let error = false;
  const customerErrorObj = { ...customerErrorsObj };

  if (firstName === '') {
    customerErrorObj.customerFirstName = t('calendar.errors.firstNameRequired');
    error = true;
  }

  if (lastName === '') {
    customerErrorObj.customerLastName = t('calendar.errors.lastNameRequired');
    error = true;
  }

  if (mobile !== undefined && mobile !== null) {
    if (mobile.length > 0) {
      if (mobile.length !== 11) {
        customerErrorObj.customerMobile = t('calendar.errors.invalidMobile');
        error = true;
      }
    }
  }

  if (email === '') {
    customerErrorObj.customerEmail = t('calendar.errors.emailRequired');
    error = true;
  } else {
    if (!validEmail.test(email)) {
      customerErrorObj.customerEmail = t('calendar.errors.invalidEmail');
      error = true;
    }
  }

  setCustomerErrors(customerErrorObj);
  if (error) {
    return;
  } else {
    setSaveCustomerButtonLoading(true)
    // add customer
    AddCustomer(
      firstName,
      lastName,
      mobile,
      email,
      customerNotes,
      customerBlocked,
    ).then((res) => {
      notifySuccess(t('calendar.toasts.customerSaved'))
      const newCustomerObject = {
        customerId: res.data,
        firstName,
        lastName,
        mobile,
        email,
        notes: customerNotes,
        isBlocked: customerBlocked
      }
      setCustomerIdToEdit(res.data)
      setCustomerDetailsObject(newCustomerObject)
      dispatch({ type: 'addCustomerClose' })
      setCustomerList([])
      GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
    }).catch((error) => {
      notifyError(t('calendar.toasts.createCustomerError'))
    }).finally((f) => {
      setSaveCustomerButtonLoading(false)
    })
  }
}

 // assumes: const { t } = useTranslation('calendar');

function onSubmitAppointmentClick(e) {
  setCommunicationType("appointment changed")
  // e.preventDefault();
  let error = false;

  if (selectedBarber === undefined || selectedBarber === null) {
    appointmentErrorsObj.barber = t('calendar.errors.required');
    error = true;
  }

  if (selectedService === undefined || selectedService === null) {
    appointmentErrorsObj.service = t('calendar.errors.required');
    error = true;
  }

  if (startDateTime === undefined || startDateTime === null) {
    appointmentErrorsObj.date = t('calendar.errors.required');
    error = true;
  }
  if (duration === undefined || duration === null) {
    appointmentErrorsObj.duration = t('calendar.errors.required');
    error = true;
  }
  if (customerDetailsObject === null) {
    appointmentErrorsObj.customer = t('calendar.errors.addCustomer');
    error = true;
  }

  setAppointmentErrors(appointmentErrorsObj);
  if (error) {
    return;
  } else {
    var calanderAppointmentsForBarber = []
    if (isEditAppointment) {
      calanderAppointmentsForBarber = eventData.filter(x => x.eventType === 1 && x.resourceId === selectedBarber.value && x.eventId !== appointmentIdToEdit)
    } else {
      calanderAppointmentsForBarber = eventData.filter(x => x.eventType === 1 && x.resourceId === selectedBarber.value && !x.cancelled)
    }
    const clashedEvents = eventClashChecker(calanderAppointmentsForBarber, new Date(startDateTime), new Date(endDateTime))

    if (clashedEvents.length > 0){
      MyAlert.fire({
        icon: 'error',
        title: t('calendar.alerts.appointmentClashTitle'),
        html: `${t('calendar.alerts.clashIntro')} <b>` +
          clashedEvents.map((clashedEvent) => {
            return '<br/>' + clashedEvent.title + '&nbsp &nbsp' +
              ("0" + new Date(clashedEvent.start).getHours()).slice(-2) + ':' +
              ("0" + new Date(clashedEvent.start).getMinutes()).slice(-2) + ' - ' +
              ("0" + new Date(clashedEvent.end).getHours()).slice(-2) + ':' +
              ("0" + new Date(clashedEvent.end).getMinutes()).slice(-2)
          })
      })
    } else {
      const blockOutForBarber = eventData.filter(x => x.eventType === 'CalendarBlockOut' && x.resourceId === selectedBarber.value && x.eventId !== appointmentIdToEdit)
      const clashedEvents = eventClashChecker(blockOutForBarber, new Date(startDateTime), new Date(endDateTime))
      if (clashedEvents.length > 0) {
        MyAlert.fire({
          icon: 'error',
          title: t('calendar.alerts.staffNotWorkingTitle'),
          html: t('calendar.alerts.chooseDifferentStaff')
        })
      } else {
        const createdBy = "Shop";
        const calanderHolidaysForBarber = eventData.filter(x => (x.eventType === 2 || x.eventType === 3)  && x.resourceId === selectedBarber.value)
        const clashedWithHolidays = eventClashChecker(calanderHolidaysForBarber, new Date(startDateTime), new Date(endDateTime))
        if (clashedWithHolidays.length > 0){
          MyAlert.fire({
            title: isEditAppointment ? t('calendar.alerts.editAppointmentConfirm') : t('calendar.alerts.addAppointmentConfirm'),
            text: t('calendar.alerts.breakDuringAppointment'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'var(--primary)',
            cancelButtonColor: '#aaa',
            confirmButtonText: t('calendar.actions.changeBreak')
          }).then((result) => {
            if (result.isConfirmed) {
              if (isEditAppointment) {
                setAppointmentActionLoading(true)
                EditAppointment(
                  appointmentIdToEdit,
                  customerIdToEdit,
                  selectedBarber.value,
                  selectedService.value,
                  startDateTime,
                  endDateTime,
                  duration.value,
                  appointmentNotes,
                  customerDetailsObject.firstName,
                  customerDetailsObject.lastName,
                  customerDetailsObject.mobile,
                  customerDetailsObject.email,
                  customerDetailsObject.notes,
                  customerDetailsObject.isBlocked,
                  createdBy,
                  true
                ).then((res) => {
                  notifySuccess(t('calendar.toasts.appointmentEdited'))
                  dispatch({type:'AddAppointmentClose'})
                  GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
                  resetAppointmentModal()
                  OpenSendCommunicationModal("appointment changed")
                }).catch((error) => {
                  notifyError(t('calendar.toasts.unableAddAppointment'))
                }).finally((f) => {
                  setIsEditAppointment(false)
                  setAppointmentActionLoading(false)
                })
              } else {
                setAppointmentActionLoading(true)
                AddAppointment(
                  selectedBarber.value,
                  customerDetailsObject.customerId,
                  selectedService.value,
                  startDateTime,
                  endDateTime,
                  duration.value,
                  appointmentNotes,
                  createdBy,
                  true
                ).then((res) => {
                  notifySuccess(t('calendar.toasts.appointmentAdded'))
                  dispatch({type:'AddAppointmentClose'})
                  GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
                  resetAppointmentModal()
                }).catch((error) => {
                  notifyError(t('calendar.toasts.unableAddAppointment'))
                }).finally((f) => {
                  setAppointmentActionLoading(false)
                })
              }
            }
          })
        } else {
          if (isEditAppointment) {
            setAppointmentActionLoading(true)
            EditAppointment(
              appointmentIdToEdit,
              customerIdToEdit,
              selectedBarber.value,
              selectedService.value,
              startDateTime,
              endDateTime,
              duration.value,
              appointmentNotes,
              customerDetailsObject.firstName,
              customerDetailsObject.lastName,
              customerDetailsObject.mobile,
              customerDetailsObject.email,
              customerDetailsObject.notes,
              customerDetailsObject.isBlocked,
              createdBy
            ).then((res) => {
              notifySuccess(t('calendar.toasts.appointmentEdited'))
              dispatch({type:'AddAppointmentClose'})
              GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
              resetAppointmentModal()
              OpenSendCommunicationModal("appointment changed")
            }).catch((error) => {
              notifyError(t('calendar.toasts.unableAddAppointment'))
            }).finally((f) => {
              setIsEditAppointment(false)
              setAppointmentActionLoading(false)
            })
          } else {
            setAppointmentActionLoading(true)
            AddAppointment(
              selectedBarber.value,
              customerDetailsObject.customerId,
              selectedService.value,
              startDateTime,
              endDateTime,
              duration.value,
              appointmentNotes,
              createdBy
            ).then((res) => {
              notifySuccess(t('calendar.toasts.appointmentAdded'))
              dispatch({type:'AddAppointmentClose'})
              GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config)
              resetAppointmentModal()
            }).catch((error) => {
              notifyError(t('calendar.toasts.unableAddAppointment'))
            }).finally((f) => {
              setAppointmentActionLoading(false)
            })
          }
        }
      }
    }
  }
}

function searchForCustomer() {
  if (searchCustomerKeyword === null || searchCustomerKeyword === undefined || searchCustomerKeyword === "") {
    setSearchForCustomerError(t('calendar.errors.enterSearchKeyword'))
  } else {
    setSearchForCustomerError()
    setCustomerSearchLoading(true)
    GetCustomers(
      searchCustomerKeyword
    ).then((res) => {
      if (res.data.length > 0) {
        var customerSelectionList = [];
        res.data.forEach(customer => {
          var customerSelection = {value: customer.customerId, label: customer.customerEmail, firstName: customer.customerFirstName, lastName: customer.customerLastName, mobile: customer.customerMobile, notes: customer.customerNotes, isBlocked: customer.customerIsBlocked}
          customerSelectionList.push(customerSelection)
        })
        setCustomerList(customerSelectionList)
      } else {
        setSearchForCustomerError(t('calendar.errors.noCustomersFound'))
      }
    }).catch((error) => {
      notifyError(t('calendar.toasts.unableSearchCustomers'))
    }).finally((f) => {
      setCustomerSearchLoading(false)
    })
  }
}


function selectCustomerFromCustomerSelectionList(customer) {
  setFirstName(customer.firstName)
  setLastName(customer.lastName)
  setMobile(customer.mobile)
  setEmail(customer.label)
  setCustomerNotes(customer.notes)
  setCustomerBlocked(customer.isBlocked)
}

function OnHolidaySubmitClick(e, editOption) {
  console.log("here");
  e.preventDefault();
  let error = false;

  // Validation mapped to i18n
  if (holidayTitle === "" || holidayTitle === null || holidayTitle === undefined) {
    holidayErrorsObj.holidayTitle = t('calendar.errors.holidayTitleRequired');
    error = true;
  }

  if (selectedBarberForHoliday === undefined || selectedBarberForHoliday === null) {
    holidayErrorsObj.holidayBarber = t('calendar.errors.holidayBarberRequired');
    error = true;
  }

  if (startDateHoliday === undefined || startDateHoliday === null) {
    holidayErrorsObj.holidayStartDate = t('calendar.errors.holidayStartDateRequired');
    error = true;
  }

  if (startTimeHoliday === undefined || startTimeHoliday === null) {
    holidayErrorsObj.holidayStartTime = t('calendar.errors.holidayStartTimeRequired');
    error = true;
  }

  if (endTimeHoliday === undefined || endTimeHoliday === null) {
    holidayErrorsObj.holidayEndTime = t('calendar.errors.holidayEndTimeRequired');
    error = true;
  }

  if (startTimeHoliday !== undefined && endTimeHoliday !== undefined) {
    if (endTimeHoliday <= startTimeHoliday) {
      holidayErrorsObj.holidayEndTime = t('calendar.errors.holidayEndTimeInvalid');
      error = true;
    }
  }

  if (isRecurringEvent) {
    if (recurringFrequency === undefined || recurringFrequency === null) {
      holidayErrorsObj.holidayRecurrenceFrequency = t('calendar.errors.holidayRecurrenceFrequencyRequired');
      error = true;
    }
    const start = new Date(startDateTimeHoliday).setHours(0, 0, 0, 0);
    const end = new Date(endDateTimeHoliday).setHours(0, 0, 0, 0);
    if (start !== end) {
      holidayErrorsObj.holidayEndDateTime = t('calendar.errors.holidayEndDateTimeSpanInvalid');
      error = true;
    }
  }

  if (endReccuranceDate !== undefined || endReccuranceDate !== null) {
    if (new Date(endReccuranceDate) < new Date(startDateTimeHoliday).setHours(0, 0, 0, 0)) {
      holidayErrorsObj.holidayRecurrenceEndDate = t('calendar.errors.holidayRecurrenceEndDateInvalid');
      error = true;
    }
  }

  setHolidayErrors(holidayErrorsObj);
  if (error) return;

  setBreakButtonLoading(true);

  // Build start/end datetimes
  const s = new Date(startDateHoliday);
  s.setHours(startTimeHoliday['$H']);
  s.setMinutes(startTimeHoliday['$m']);

  const en = new Date(startDateHoliday);
  en.setHours(endTimeHoliday['$H']);
  en.setMinutes(endTimeHoliday['$m']);

  setStartDateTimeHoliday(s);
  setEndDateTimeHoliday(en);

  // Clash check
  const barbersEvents = eventData.filter(
    x => x.eventType === 1 && x.resourceId === selectedBarberForHoliday.value && !x.cancelled
  );
  const clashWithAppointments = eventClashChecker(barbersEvents, new Date(s), new Date(en));

  const proceedWithHoliday = () => {
    if (isHolidayEdit) {
      EditHoliday(
        holidayToEdit,
        holidayTitle,
        selectedBarberForHoliday.value,
        s,
        en,
        isRecurringEvent ? "Recurring" : "Single",
        recurringFrequency,
        endReccuranceDate,
        editOption
      ).then(() => {
        notifySuccess(t('calendar.toasts.breakEdited'));
        dispatch({ type: 'editHolidayOptionsClose' });
        GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config);
        resetHolidaysModal();
        setIsHolidayEdit(false);
      }).catch(() => {
        notifyError(t('calendar.toasts.unableEditBreak'));
      }).finally(() => {
        dispatch({ type: 'addHolidayClose' });
        setBreakButtonLoading(false);
      });
    } else {
      AddHoliday(
        holidayTitle,
        selectedBarberForHoliday.value,
        s,
        en,
        isRecurringEvent ? "Recurring" : "Single",
        recurringFrequency,
        endReccuranceDate
      ).then(() => {
        notifySuccess(t('calendar.toasts.breakAdded'));
        dispatch({ type: 'addHolidayClose' });
        GetEventsWrapper(barberData, selectedDate, resourceLanes, services, config);
        resetHolidaysModal();
      }).catch(() => {
        notifyError(t('calendar.toasts.unableAddBreak'));
      }).finally(() => {
        setBreakButtonLoading(false);
        dispatch({ type: 'addHolidayClose' });
      });
    }
  };

  if (clashWithAppointments.length > 0) {
    MyAlert.fire({
      title: isHolidayEdit ? t('calendar.alerts.editBreakConfirm') : t('calendar.alerts.addBreakConfirm'),
      text: t('calendar.alerts.appointmentsDuringBreak'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'var(--primary)',
      cancelButtonColor: '#aaa',
      confirmButtonText: t('calendar.actions.changeBreak')
    }).then((result) => {
      if (result.isConfirmed) {
        proceedWithHoliday();
      } else {
        setBreakButtonLoading(false);
      }
    });
  } else {
    proceedWithHoliday();
  }
}

function onNavigate(newDate) {
  var date = new Date(newDate)
  setSelectedDate(date);
  GetEventsWrapper(barberData, date, resourceLanes, services, config);
}

const onForwardDate = () => {
  var date = new Date(selectedDate)
  date.setDate(date.getDate() + 1)
  setSelectedDate(date)
  GetEventsWrapper(barberData, date, resourceLanes, services, config)
}

const onBackwardsDate = () => {
  var date = new Date(selectedDate)
  date.setDate(date.getDate() - 1)
  setSelectedDate(date)
  GetEventsWrapper(barberData, date, resourceLanes, services, config)
}

const calendarFormats = useMemo(() => ({
  timeGutterFormat: 'HH:mm'
}), [])




return (
  <div>
    <div className="h-80">



  <ToastContainer />

      {barbersWithClash.length !== 0 && (
        <div className="sched-alert">
          {barbersWithClash.length === 1 ? (
            <span>{barbersWithClash[0]} has an appointment clash today!</span>
          ) : barbersWithClash.length === 2 ? (
            <span>{barbersWithClash[0]} and {barbersWithClash[1]} have double booked appointments today!</span>
          ) : (
            <span>
              {barbersWithClash.map((v, i) => {
                if (i < barbersWithClash.length - 2) return v + ", ";
                if (i === barbersWithClash.length - 1) return " and " + v + " all have double booked appointments today!";
                return v;
              })}
            </span>
          )}
        </div>
      )}



    {showCalendar ? (
        <div className="sched-topbar">
          <div className="topbar-left">
            <IconButton onClick={onBackwardsDate} className="nav-icon"><ArrowBackIcon fontSize="small" /></IconButton>

            <button
              ref={dateBtnRef}
              type="button"
              className="date-btn"
              onClick={() => setDateOpen(v => !v)}
              aria-haspopup="dialog"
              aria-expanded={dateOpen}
            >
              <CalendarMonthIcon className="date-btn__icon" />
              <span className="date-btn__text">
                {new Intl.DateTimeFormat(i18n.language || "en", { weekday: "short", day: "2-digit", month: "short", year: "numeric" })
                  .format(selectedDate).replace(/,/g, "")}
              </span>
            </button>



            <IconButton onClick={onForwardDate} className="nav-icon"><ArrowForwardIcon fontSize="small" /></IconButton>
          </div>

          <div className="topbar-right">
                        <Button
              className="btn-today"
              onClick={() => {
                const d = new Date();
                console.log("d " + d);
                setSelectedDate(d);
                GetEventsWrapper(barberData, d, resourceLanes, services, config);
              }}
              style={{ backgroundColor: isSelectedDateToday ? "var(--button-color)" : "grey", border: "none" }}
            >{t('calendar.toolbar.today')}</Button>
            <button
              ref={filterBtnRef}
              type="button"
              className="filter-btn"
              onClick={() => setFilterOpen(v => !v)}
              aria-haspopup="dialog"
              aria-expanded={filterOpen}
              title={t('calendar.labels.filterBarbers')}
            >
              <FilterListIcon />
              <span>{t('calendar.actions.filter')}</span>
            </button>

            <Link
              to="#"
              className="btn-primary-ghost"
              onClick={() => {
                dispatch({ type: "addEventOptionsOpen" });
                resetAppointmentModal();
                setMemEvent()
              }}
            >{t('calendar.actions.addEvent')}</Link>
          </div>
        </div>
      ):<></>}

      <DatePopover
        anchorRef={dateBtnRef}
        open={dateOpen}
        onClose={() => setDateOpen(false)}
        selectedDate={selectedDate}
        onPick={(d) => { onNavigate(d); setDateOpen(false); }}
      />

      <BarberPopover
        anchorRef={filterBtnRef}
        open={filterOpen}
        onClose={() => setFilterOpen(false)}
        barbers={barberData}
        resourceLanes={resourceLanes}
        onPick={(id, name) => { onClickBarberName(id, name);}}
      />

      



{showCalendar ? 
    <div className="calendar-shell">
      <div>
                  <DnDCalendar
                  formats={calendarFormats}
                  defaultDate={today}
                  date={selectedDate}
                  defaultView={Views.DAY}
                  events={eventData}
                  localizer={localizer}
                  resourceIdAccessor="value"
                  resources={resourceLanes}
                  resourceTitleAccessor="label"
                  onEventDrop={e => {onEventDrop(e)}}
                  onEventResize={e => {onEventResize(e)}}
                  onDoubleClickEvent={(e) => {onSelectEvent(e)}}
                  onNavigate={onNavigate}
                  min={minDateTime}
                  max={maxDateTime}
                  resizable
                  resizableAccessor={'isResizable'}
                  step={calendarStep}
                  // formats = {formats(test)}
                  selectable
                  scrollToTime={selectedDate.setHours(9)}
                  timeslots={1}
                  toolbar={false}
                  longPressThreshold={150}
                  views={views}
                  draggableAccessor={'isDraggable'}
                  selectableAccessor={false}
                  showMultiDayTimes={true}
                  // onDragging={(e) => {console.log('dragging')}}
                  onSelectSlot={(e) => {onSelectSlot(e)}}
                  eventPropGetter={(myEventsList) => {
                    const backgroundColor = myEventsList.colorEvento ? myEventsList.colorEvento : 'blue';
                    const borderRadius = myEventsList.isCalanderBlock ? '0' : '';
                    const border = myEventsList.isCalanderBlock ? 'none' : '';
                    const color = myEventsList.isCalanderBlock ? '#dedede' : myEventsList.eventType === 4 ? "#e79595ff":''
                    const withClass = myEventsList.isCalanderBlock ? 'calendar-block-out-background' : ''
                    const full = myEventsList.fullDay ? 'full' : ''
                    const app = myEventsList.eventType === 1 ? 'app' : ''
                    // const width = '100% !important';
                    return { style: { backgroundColor, borderRadius, border, color}, className: withClass + ' ' + full + ' ' + app}
                  }}
                />
                </div>
                </div> :

          <div className="custom-loader-wrapper">
                      <div className="custom-loader"></div>
                    </div>
}

      <Modal className="modal fade" show={state.addEventOptions} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('calendar.labels.chooseEventType')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => dispatch({type:'addEventOptionsClose'})}></Button>
          </div>
          <div className="sm-modal__body" style={{display:'flex', justifyContent:'space-around'}}>
          <Link to={"#"} onClick={(e) => {CreateAppointmentOption(e)}} className="btn-custom btn-primary mb-1 ms-1 modal-option-btn">{t('calendar.labels.appointment')}</Link>
          <Link to={"#"} onClick={(e) => {CreateHolidayOption(e)}} className="btn-custom btn-primary mb-1 ms-1 modal-option-btn">{t('calendar.labels.break')}</Link>
          </div>
        </div>
      </Modal>

<Modal enforceFocus={false} className="modal fade" show={state.addAppointment} centered>
  <div className="sm-modal">
    {/* Header */}
    <div className="sm-modal__header">
      <h5 className="sm-modal__title">
        {isEditAppointment ? t('calendar.actions.editAppointment') : t('calendar.actions.addAppointment')}
      </h5>
      <Button
        variant=""
        type="button"
        className="btn-close"
        data-dismiss="modal"
        onClick={() => {dispatch({ type: "AddAppointmentClose"}); resetAppointmentModal(); setMemEvent();}}
      />
    </div>

    {/* Body */}
    <div className="sm-modal__body">
      {(memEvent !== undefined && memEvent !== null) ? (
        <p className="sm-subtle">
          {memEvent.createdBy === "Customer"
            ? t('calendar.createdBy.customer')
            : t('calendar.createdBy.shop')}
        </p>
      ) : null}

      <form className="sm-form" onSubmit={onSubmitAppointmentClick}>
        <div className="sm-grid sm-grid--2">
          {/* Barber */}
          <div className={`sm-field ${appointmentErrors.barber ? "is-error" : ""}`}>
            <label className="sm-label">
              {t('calendar.placeholders.selectStaff')}<span className="sm-req">*</span>
            </label>
            <Select
            isSearchable={false}
              placeholder={t('calendar.labels.staff')}
              closeMenuOnSelect
              options={barberList}
              defaultValue={selectedBarber}
              isDisabled={isAppointmentCancelled || appointmentModalDisabled}
              onChange={(e) =>
                setSelectedBarber({
                  value: e.value,
                  label: e.label,
                  workingDayArray: e.workingDayArray,
                  services: e.services
                })
              }
              className="sm-select"
              classNamePrefix="rs"
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
            {appointmentErrors.barber && <div className="sm-error">{appointmentErrors.barber}</div>}
          </div>

          {/* Service */}
          <div className={`sm-field ${appointmentErrors.service ? "is-error" : ""}`}>
            <label className="sm-label">{t('calendar.placeholders.selectService')}<span className="sm-req">*</span>
            </label>
            <Select
              isSearchable={false}
              placeholder={t('calendar.labels.services')}
              closeMenuOnSelect
              options={selectedBarber !== undefined ? services.filter(opt => selectedBarber?.services?.includes(opt.label)) : null}
              defaultValue={selectedService}
              isDisabled={isAppointmentCancelled || appointmentModalDisabled || selectedBarber === undefined}
              onChange={selectServiceHandler}
              className="sm-select"
              classNamePrefix="rs"
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
            {appointmentErrors.service && <div className="sm-error">{appointmentErrors.service}</div>}
          </div>

          {/* Date & Time */}
          <div className={`sm-field sm-field--spaced ${appointmentErrors.date ? "is-error" : ""}`}>

            <InlineDateTimeInputPro
              label={t('calendar.labels.chooseDate')}
              required
              value={startDateTime}  
              disabled={isAppointmentCancelled || appointmentModalDisabled || selectedBarber === undefined}                   // Date | null
              onChange={(d) => startDateHandler(d)}     // keep your existing logic
              minuteStep={minStep}                      // 10/15/20...
              disablePast={true}
              isDateAllowed={(jsDate) => {
                // replicate your shouldDisableDate using selectedBarber.workingDayArray
                if (!selectedBarber?.workingDayArray) return true;
                const dayIndex = jsDate.getDay(); // 0..6
                return selectedBarber.workingDayArray.some(d => d - 1 === dayIndex);
              }}
            />
            {appointmentErrors.date && <div className="sm-error">{appointmentErrors.date}</div>}
          </div>

          {/* Duration */}
          <div className={`sm-field sm-field--spaced ${appointmentErrors.duration ? "is-error" : ""}`}>
            <label className="sm-label">{t('calendar.labels.duration')}<span className="sm-req">*</span>
            </label>
            <Select
            isSearchable={false}
              closeMenuOnSelect
              options={timeSelection}
              value={duration}
              isDisabled={isAppointmentCancelled || appointmentModalDisabled}
              onChange={addDuration}
              className="sm-select"
              classNamePrefix="rs"
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              menuPosition="fixed"
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
            {appointmentErrors.duration && <div className="sm-error">{appointmentErrors.duration}</div>}
          </div>
        </div>

        {/* Notes */}
        <div className="sm-field sm-field--spaced">
          <label className="sm-label">{t('calendar.labels.notes')}</label>
          <textarea
            rows={6}
            className="sm-textarea"
            name="customerNotes"
            disabled={isAppointmentCancelled || appointmentModalDisabled}
            value={appointmentNotes}
            maxLength={250}
            onChange={(e) => setAppointmentNotes(e.target.value)}
          />
          {appointmentErrors.appointmentNotes && (
            <div className="sm-error">{appointmentErrors.appointmentNotes}</div>
          )}
        </div>

                {/* Customer row (with Add/Edit button) */}
        <div className="sm-field sm-field--row sm-field--spaced">
          {(!isAppointmentCancelled && !appointmentModalDisabled) && (
            <div className="sm-field__actions">
              {customerDetailsObject === null ? (
                <Link
                  to="#"
                  className="btn-custom btn-primary"
                  onClick={() => dispatch({ type: "addCustomerOpen" })}
                >{t('calendar.actions.addCustomer')}</Link>
              ) : (
                <Link
                  to="#"
                  className="btn-custom btn-primary"
                  onClick={() => {
                    dispatch({ type: "addCustomerOpen" });
                    loadCustomerDetails();
                  }}
                >
                  {t('calendar.labels.EditCustomer')}
                </Link>
                
              )}
              {appointmentErrors.customer && <div className="sm-error mt-3">{appointmentErrors.customer}</div>}
            </div>
          )}
        </div>

        {/* Appointment summary */}
        <div className="sm-section">
          <div className="sm-section__head">{t('calendar.appointment.summary')}</div>
          <ul className="sm-list">
            {(startDateTime !== undefined && endDateTime !== undefined && duration !== undefined) ? (
              <li>
                <span className="sm-list__label">{t('calendar.labels.date')}:</span>
                <span className="sm-list__value">
              <span className="date-btn__text">
                {new Intl.DateTimeFormat(i18n.language || "en", { weekday: "short", day: "2-digit", month: "short" })
                  .format(startDateTime).replace(/,/g, "")}
              </span>
              <span> </span>
                <span className="date-btn__text">
                {new Intl.DateTimeFormat(i18n.language || "en", { hour: "2-digit", minute:"2-digit" })
                  .format(startDateTime)}
              </span>
              <span>-</span>
                <span className="date-btn__text">
                {new Intl.DateTimeFormat(i18n.language || "en", { hour: "2-digit", minute:"2-digit" })
                  .format(endDateTime)}
              </span>
                </span>
              </li>
            ) : (
            <li>
              <span className="sm-list__label">{t('calendar.labels.date')}:</span>
              <span className="sm-list__value">
                -
              </span>
            </li>
            )}
            <li>
              <span className="sm-list__label">{t('calendar.labels.name')}:</span>
              <span className="sm-list__value">
                {customerDetailsObject
                  ? `${customerDetailsObject.firstName} ${customerDetailsObject.lastName}`
                  : "-"}
              </span>
            </li>
            <li>
              <span className="sm-list__label">{t('calendar.labels.email')}:</span>
              <span className="sm-list__value">
                {customerDetailsObject ? customerDetailsObject.email : "-"}
              </span>
            </li>
            {selectedService !== undefined && (
            (((services.filter(x => x.value === selectedService.value)[0].acceptOnlinePayment) & (config.acceptOnlinePayments)) || (paidAmount>0)) ?  (
              <>
              <li>
                <span className="sm-list__label">{t('calendar.labels.paidOnline')}:</span>
                  <span className="sm-list__value">
                    {formatMinor(paidAmount, config.currency)}
                </span>
              </li>
              <li>
                <span className="sm-list__label">{t('calendar.labels.payAtAppointment')}:</span>
                  <span className="sm-list__value">
                    {formatMinor(services.filter(x => x.value === selectedService.value)[0].price - paidAmount, config.currency)}
                  </span>
              </li>
              <li>
                <span className="sm-list__label">{t('calendar.labels.refunded')}:</span>
                  <span className="sm-list__value">
                    
                    {refundAmount.toString() === "-1" ? <span style={{color:"red"}}>{t('calendar.labels.failed')}</span>:formatMinor(refundAmount, config.currency)}
                  </span>
              </li>
              </>
            ) :
            (
              <li>
                <span className="sm-list__label">{t('calendar.labels.payAtAppointment')}:</span>
                  <span className="sm-list__value">
                    {formatMinor(services.filter(x => x.value === selectedService.value)[0].price, config.currency)}
                  </span>
              </li>
            )
            )}
            <li>{appointmentCancelledByMessage && <p className="sm-footnote mt-3">{appointmentCancelledByMessage}</p>}</li>
          </ul>
        </div>



        {/* Footer actions */}
        <div className="sm-form__footer">
          {isEditAppointment ? (
            <div className="sm-flex-between">
                            <div>
                {(!isAppointmentCancelled && !appointmentModalDisabled) ? (
                  // <Link to="#" className="btn-custom btn-danger" onClick={() => onCancelAppointment(0)}>
                  //   Cancel
                  // </Link>
                  <BackButton label={t('calendar.actions.cancelRefund')} loading={cancellingAppointmentLoading} onClick={() => onCancelAppointment(0)}> </BackButton>
                ) : null}
              </div>
              {/* <div>
                {(!isAppointmentCancelled && !appointmentModalDisabled) ? (

                  <BackButton label={t('calendar.actions.cancel')} loading={cancellingAppointmentLoading} onClick={() => onCancelAppointment(0)}> </BackButton>
                ) : (cancelledBy === "Shop" && !appointmentModalDisabled) ? (

                  <BackButton label={t('calendar.actions.reinstate')} onClick={() => onCancelAppointment(1)} loading={cancellingAppointmentLoading}> </BackButton>
                ) : null}
              </div> */}
              <div>
                {(!isAppointmentCancelled && !appointmentModalDisabled) && (
                  <CustomButton className="app-btn--sm" onClick={onSubmitAppointmentClick} label={t('calendar.labels.EditAppointment')} loading={appointmentActionLoading} />
                )}
              </div>
            </div>
          ) : (
            <div className="sm-right">
              <div className="sm-actions sm-grid__full">
                  <CustomButton className="app-btn--sm" onClick={onSubmitAppointmentClick} label={t('calendar.labels.AddAppointment')} loading={appointmentActionLoading} />
              </div>
              {/* <Link to="#" className="btn-custom btn-primary" onClick={onSubmitAppointmentClick}>
                Add Appointment
              </Link> */}
            </div>
          )}
        </div>
      </form>
    </div>
  </div>
</Modal>


          <Modal enforceFocus={false} className="modal fade" show={state.sendCommunication} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('calendar.actions.sendCommunication')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'sendCommunicationClose'}); setCommunicationType(); setMemEvent();}}></Button>
          </div>
          <div className="sm-modal__body">
          <form className="sm-form" onSubmit={onSubmitSendCommunicationClick}>



              <div className="row mb-3">
                <div className="mt-2 col-lg-12">


                  <div className={`sm-field`} style={{ gridColumn: "1 / -1" }}>
                    <label className="sm-label mb-2">{t('calendar.labels.message')}</label>
                    <textarea
                      rows={7}
                      className="sm-textarea"
                      name="customerNotes"
                      defaultValue={customerAppointmentChangeMessage}
                      maxLength={500}
                      placeholder=""
                      onChange={(e) => setCustomerAppointmentChangeMessage(e.target.value)}
                    />
                  </div>



                  {communicationType === "appointment changed" ? <><p style={{fontSize:'0.9rem'}}>{t('calendar.labels.appointmentChangedFooter.details')}</p> <p style={{fontSize:'0.9rem'}}>{t('calendar.labels.appointmentChangedFooter.sentTo')} {memEvent === undefined ? '' : memEvent.email}</p></> :
                   <></>}
                </div>
                {/* <div className="col-lg-12">
                    <div style={{display:'flex', justifyContent:'end'}}>
                    <Link to={"#"} className="mt-2 btn-custom btn-primary" onClick={onSubmitSendCommunicationClick}>{t('calendar.actions.sendEmail')}</Link>
                    </div>
                </div> */}
              </div>
              <div className="sm-actions">
                  <CustomButton className="app-btn--sm" onClick={onSubmitSendCommunicationClick} label={t('calendar.labels.sendEmail')} loading={customerSaveButtonLoading} />
              </div>
            </form>
          </div>
        </div>
      </Modal>
 <Modal className="modal fade" show={state.addCustomer} centered>
  <div className="sm-modal sm-modal--md">
    <div className="sm-modal__header">
      <h5 className="sm-modal__title">{t('calendar.labels.customer')}</h5>

      <IconButton aria-label={t('calendar.actions.back')} size="large">
        <ArrowBackIcon
          className="customer-modal-back-arrow"
          onClick={() => {
            dispatch({ type: "addCustomerClose" });
            setCustomerList([]);
            setSearchForCustomerError();
            setCustomerErrors(customerErrorsObj);
            setSearchCustomerKeyword();
          }}
        />
      </IconButton>
    </div>

    <div className="sm-modal__body">
      <form className="sm-form" onSubmit={OnCustomerSubmitClick}>
        {/* Search / Select block */}
        {customerList.length > 0 ? (
          <>
            <div className="sm-row sm-row--inline">
              <div className="sm-col sm-col--grow">
                <div className="sm-field">
                  <label className="sm-label">{t('calendar.labels.selectCustomer')}</label>

                  <Select
                    isSearchable={false}
                    placeholder={t('calendar.actions.select')}
                    closeMenuOnSelect
                    options={customerList}
                    onChange={(e) => {
                      selectCustomerFromCustomerSelectionList(e);
                    }}
                    className="sm-select"
                    classNamePrefix="rs"
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 1600 }) }}
                  />



                  <div className="sm-help">
                    {customerList.length > 1 ? t('calendar.customersFound_more', { count: customerList.length }) : customerList.length === 0 ? "no" : t('calendar.customersFound_one', { count: customerList.length })}
                  </div>
                </div>
              </div>
              <div className="sm-col sm-col--auto">
                <button
                  type="button"
                  style={{ border: "none", marginBottom: "0.5rem" }}
                  className="icon-btn"
                  aria-label={t('calendar.actions.clearResults')}
                  title={t('calendar.actions.clearResults')}
                  onClick={() => {
                    setCustomerList([]);
                    setSearchCustomerKeyword();
                  }}
                >
                  <CancelIcon fontSize="small" />
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="sm-row sm-row--inline sm-searchRow">
              <div className="sm-col sm-col--grow">
                <div className="sm-field sm-field--error-slot">
                  <label className="sm-label">{t('calendar.labels.customerSearch')}</label>

                  <div className="sm-searchRow__wrap">
                    <input
                      type="text"
                      className="sm-input sm-searchRow__input"
                      name="customerFirstName"
                      placeholder={t('calendar.placeholders.searchNameOrEmail')}
                      value={searchCustomerKeyword}
                      onChange={(e) => setSearchCustomerKeyword(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.nativeEvent.isComposing) {
                          e.preventDefault();
                          e.stopPropagation();
                          searchForCustomer();
                        }
                      }}
                    />

                    <CustomButton
                      className="app-btn--sm"
                      onClick={searchForCustomer}
                      label={t('calendar.actions.search')}
                      loading={customerSearchLoading}
                    />
                  </div>
                  <div className='mt-1'>
                  {searchForCustomerError && (
                    <div className="sm-error">{searchForCustomerError}</div>
                  )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <hr className="sm-hr" />

        {/* Form grid */}
        <div className="sm-grid sm-grid--2 sm-grid--gap">
          <div className={`sm-field ${customerErrors.customerFirstName ? "is-error" : ""}`}>
            <label className="sm-label">
              {t('calendar.labels.firstName')}<span className="sm-req">*</span>
            </label>
            <input
              type="text"
              className="sm-input"
              name="customerFirstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            {customerErrors.customerFirstName && (
              <div className="sm-error">{customerErrors.customerFirstName}</div>
            )}
          </div>

          <div className={`sm-field ${customerErrors.customerLastName ? "is-error" : ""}`}>
            <label className="sm-label">
              {t('calendar.labels.lastName')}<span className="sm-req">*</span>
            </label>
            <input
              type="text"
              className="sm-input"
              name="customerLastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            {customerErrors.customerLastName && (
              <div className="sm-error">{customerErrors.customerLastName}</div>
            )}
          </div>

          <div className={`sm-field ${customerErrors.customerMobile ? "is-error" : ""}`} style={{ gridColumn: "1 / -1" }}>
            <label className="sm-label">{t('calendar.labels.mobile')}</label>
            <input
              type="tel"
              className="sm-input"
              name="customerMobile"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
            />
            {customerErrors.customerMobile && (
              <div className="sm-error">{customerErrors.customerMobile}</div>
            )}
          </div>

          <div className={`sm-field ${customerErrors.customerEmail ? "is-error" : ""}`} style={{ gridColumn: "1 / -1" }}>
            <label className="sm-label">
              {t('calendar.labels.email')}<span className="sm-req">*</span>
            </label>
            <input
              type="email"
              className="sm-input"
              name="customerEmail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {customerErrors.customerEmail && (
              <div className="sm-error">{customerErrors.customerEmail}</div>
            )}
          </div>

          <div className={`sm-field ${customerErrors.customerNotes ? "is-error" : ""}`} style={{ gridColumn: "1 / -1" }}>
            <label className="sm-label">{t('calendar.labels.notes')}</label>
            <textarea
              rows={6}
              className="sm-textarea"
              name="customerNotes"
              value={customerNotes}
              maxLength={250}
              onChange={(e) => setCustomerNotes(e.target.value)}
            />
            {customerErrors.customerNotes && (
              <div className="sm-error">{customerErrors.customerNotes}</div>
            )}
          </div>

          <div className="sm-field" style={{ gridColumn: "1 / -1" }}>
            <label className="sm-label">{t('calendar.labels.status')}</label>
            <label className="sm-check">
              <input
                type="checkbox"
                className="sm-check__input"
                id="isBlocked"
                checked={!!customerBlocked}
                onChange={(e) => setCustomerBlocked(e.target.checked)}
              />
              <span className="sm-check__box" aria-hidden="true"></span>
              <span className="sm-check__label">{t('calendar.labels.blocked')}</span>
            </label>
          </div>
        </div>

        {/* Actions */}
        <div className="sm-actions">
          <CustomButton
            className="app-btn--sm"
            onClick={OnCustomerSubmitClick}
            label={t('calendar.actions.save')}
            loading={saveCustomerButtonLoading}
          />
        </div>
      </form>
    </div>
  </div>
</Modal>

          <Modal enforceFocus={false} className="modal fade" show={state.addHoliday} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{isHolidayEdit ? t('calendar.actions.editBreak') : t('calendar.actions.addBreak')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => {dispatch({type:'addHolidayClose'}); resetHolidaysModal()}}></Button>
          </div>
          <div className="sm-modal__body">
          <form className="sm-form" onSubmit={OnHolidaySubmitClick}>
            <div className="sm-grid sm-grid--2">
              {/* Title */}
              <div className={`sm-field ${holidayErrors.holidayTitle ? "is-error" : ""}`}>
                <label className="sm-label">{t('calendar.labels.title')}<span className="sm-req">*</span></label>
                <input
                  type="text"
                  className="sm-input"
                  name="holidayTitle"
                  value={holidayTitle || ""}
                  onChange={(e) => setHolidayTitle(e.target.value)}
                />
                {holidayErrors.holidayTitle && <div className="sm-error">{holidayErrors.holidayTitle}</div>}
              </div>

              {/* Staff */}
              <div className={`sm-field ${holidayErrors.holidayBarber ? "is-error" : ""}`}>
                <label className="sm-label">{t('calendar.placeholders.selectStaff')}<span className="sm-req">*</span></label>
                <Select
                isSearchable={false}
                  placeholder={t('calendar.labels.staff')}
                  closeMenuOnSelect
                  components={{ ClearIndicator }}
                  styles={{ clearIndicator: ClearIndicatorStyles }}
                  defaultValue={selectedBarberForHoliday}
                  options={barberList}
                  onChange={(e) => setSelectedBarberForHoliday({ value: e.value, label: e.label })}
                  className="sm-select"
                  classNamePrefix="rs"
                />
                {holidayErrors.holidayBarber && <div className="sm-error">{holidayErrors.holidayBarber}</div>}
              </div>

              {/* Date */}
              <div className={`sm-field sm-grid__full ${holidayErrors.holidayStartDate ? "is-error" : ""}`}>
              <InlineDateInput
                label={t('calendar.labels.date')}
                required
                value={startDateHoliday}
                onChange={setStartDateHoliday}
                error={holidayErrors.holidayStartDate}
              />
              </div>

              {/* Start Time */}
              <InlineTimeInput
                label={t('calendar.labels.startTime')}
                value={startTimeHoliday}                // Dayjs or undefined
                onChange={(d) => setStartTimeHoliday(d)}
                step={minStep}
                error={holidayErrors.holidayStartTime}
              />

              <InlineTimeInput
                label={t('calendar.labels.endTime')}
                value={endTimeHoliday}                  // Dayjs or undefined
                onChange={(d) => setEndTimeHoliday(d)}
                step={minStep}
                error={holidayErrors.holidayEndTime}
              />
            </div>

            {/* Recurring */}
<div className="sm-field sm-field--stack mt-2">
  <label className="sm-label">{t('calendar.labels.recurringBreak')}</label>

  <label className="day-check">
    <input
      type="checkbox"
      className="day-check__input"
      checked={!!isRecurringEvent}
      onChange={(e) => { setIsRecurringEvent(e.target.checked); setRecurringFrequency("daily"); setEndRecuranceDate(undefined); }}
    />
    <span className="day-check__box" aria-hidden="true" />
    <span className="day-check__label">{t('calendar.labels.enableRecurrence')}</span>
  </label>
</div>

{isRecurringEvent && (
  <div className="sm-recurring">
    <div className="sm-radio-row">
      <label className="sm-radio">
        <input
          type="radio"
          name="rec"
          checked={recurringFrequency === "daily"}
          onChange={() => setRecurringFrequency("daily")}
        />
        <span>{t('calendar.labels.daily')}</span>
      </label>

      <label className="sm-radio">
        <input
          type="radio"
          name="rec"
          checked={recurringFrequency === "weekly"}
          onChange={() => setRecurringFrequency("weekly")}
        />
        <span>{t('calendar.labels.weekly')}</span>
      </label>

      <label className="sm-radio">
        <input
          type="radio"
          name="rec"
          checked={recurringFrequency === "monthly"}
          onChange={() => setRecurringFrequency("monthly")}
        />
        <span>{t('calendar.labels.monthly')}</span>
      </label>

      {holidayErrors.holidayRecurrenceFrequency && (
        <div className="sm-error">{holidayErrors.holidayRecurrenceFrequency}</div>
      )}
    </div>

    <InlineDateInput
      subLabel={t('calendar.hints.noEndDate')}
      label={t('calendar.labels.endRecurrence')}
      value={endReccuranceDate}
      onChange={setEndRecuranceDate}
      error={holidayErrors.holidayRecurrenceEndDate}
      shiftUp={true}
      style={{ marginBottom: "5rem" }}
    />
  </div>
)}


            {/* Actions */}
            <div className="sm-actions">
                                {/* {isHolidayEdit ?
                                  <div className="col-lg-12 mb-5">
                                  <div className="form-group mb-3" style={{display:'block'}}>
                                      {<Link style={{position:'absolute', backgroundColor:'#e83b2e'}} to={"#"} onClick={() => {onDeleteHoliday(4)}} className="mt-2 btn-custom btn-primary submit">{t('calendar.actions.delete')}</Link>}
                                      {<Link style={{position:'absolute', right:'0', marginRight:'2rem'}} className="mt-2 btn-custom btn-primary" onClick={isHolidayEdit && isSelectedEventRecurring ? () => {dispatch({type:'editHolidayOptionsOpen'}); dispatch({type:'addHolidayClose'})} : (e) => {OnHolidaySubmitClick(e, 4);}}>{t('calendar.actions.editBreak')}</Link>}
                                  </div>
                                  </div>
                                  :
                                  <div style={{display:'flex', justifyContent:'end'}}>
                                  <Link to={"#"} className="mt-2 btn-custom btn-primary" onClick={OnHolidaySubmitClick}>{t('calendar.actions.addBreak')}</Link>
                                  </div>
                  } */}
              {isHolidayEdit ? (
                <>

                  <BackButton style={{marginRight:"1rem"}} label={t('calendar.actions.delete')} onClick={isRecurringEvent ? (e) => {dispatch({type:'deleteHolidayOptionsOpen'}); dispatch({type:'deleteHolidayOptionsOpen'}); dispatch({type:'addHolidayClose'});} : () => {onDeleteHoliday(4)}} loading={breakDeleteLoading}> </BackButton>
                  <CustomButton className="app-btn--sm" onClick={isHolidayEdit && isSelectedEventRecurring ? () => {dispatch({type:'editHolidayOptionsOpen'}); dispatch({type:'addHolidayClose'})} : (e) => {OnHolidaySubmitClick(e, 4);}} label={t('calendar.actions.editBreak')} loading={breakButtonLoading} />

                </>
              ) : (
                // <button type="submit" className="btn-custom btn-primary">Add break</button>
                <CustomButton type="submit" className="app-btn--sm" label={t('calendar.actions.addBreak')} loading={breakButtonLoading} />
              )}
            </div>
          </form>
        </div>
      </div>
    </Modal>

              <Modal enforceFocus={false} className="modal fade" show={state.editHolidayOptions} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('calendar.actions.editOptions')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => dispatch({type:'editHolidayOptionsClose'})}></Button>
          </div>
          <div className="sm-modal__body">
            <div>

            <Link style={{marginBottom:"0.5rem", display:"block", textAlign:"center", fontSize:'0.8rem', width:'100%', fontWeight:'normal'}} to={"#"} onClick={(e) => {OnHolidaySubmitClick(e, 1);}} className="btn-custom btn-primary" >{t('calendar.series.all')}</Link>
          </div>
          <div>
            <Link style={{marginBottom:"0.5rem", display:"block", textAlign:"center", fontSize:'0.8rem', width:'100%', fontWeight:'normal'}} to={"#"} onClick={(e) => {OnHolidaySubmitClick(e, 2);}} className="btn-custom btn-primary">{t('calendar.series.thisAndFuture')}</Link>
          </div>
          <div>
            <Link style={{marginBottom:"0.5rem", display:"block", textAlign:"center", fontSize:'0.8rem', width:'100%', fontWeight:'normal'}} to={"#"} onClick={(e) => {OnHolidaySubmitClick(e, 3);}} className="btn-custom btn-primary">{t('calendar.series.thisOnly')}</Link>
          </div>
          </div>
        </div>
      </Modal>
      <Modal className="modal fade" show={state.editHolidayOptionsOnHolidayTimeSlotChange} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('calendar.actions.editOptions')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => dispatch({type:'editHolidayOptionsOnHolidayTimeSlotChangeClose'})}></Button>
          </div>
          <div className="sm-modal__body">
            <div>
            <Link style={{marginBottom:"0.5rem", display:"block", textAlign:"center", fontSize:'0.8rem', width:'100%', fontWeight:'normal'}} to={"#"} onClick={(e) => {changeHolidaySlot(1);}} className="btn-custom btn-primary">{t('calendar.series.all')}</Link>
          </div>
          <div>
            <Link style={{marginBottom:"0.5rem", display:"block", textAlign:"center", fontSize:'0.8rem', width:'100%', fontWeight:'normal'}} to={"#"} onClick={(e) => {changeHolidaySlot(2);}} className="btn-custom btn-primary">{t('calendar.series.thisAndFuture')}</Link>
          </div>
          <div>
            <Link style={{marginBottom:"0.5rem", display:"block", textAlign:"center", fontSize:'0.8rem', width:'100%', fontWeight:'normal'}} to={"#"} onClick={(e) => {changeHolidaySlot(3);}} className="btn-custom btn-primary">{t('calendar.series.thisOnly')}</Link>
          </div>
          </div>
        </div>
      </Modal>
      <Modal className="modal fade" show={state.deleteHolidayOptions} centered>
        <div className="sm-modal">
          <div className="sm-modal__header">
            <h5 className="sm-modal__title">{t('calendar.labels.deleteOptions')}</h5>
            <Button variant="" type="button" className="btn-close" data-dismiss="modal" onClick={() => dispatch({type:'deleteHolidayOptionsClose'})}></Button>
          </div>
          <div className="sm-modal__body">
            <div>
            <Link style={{marginBottom:"0.5rem", display:"block", textAlign:"center", fontSize:'0.8rem', width:'100%', fontWeight:'normal'}} to={"#"} onClick={(e) => {onDeleteHoliday(1);}} className="btn-custom btn-primary">{t('calendar.series.all')}</Link>
          </div>
          <div>
            <Link style={{marginBottom:"0.5rem", display:"block", textAlign:"center", fontSize:'0.8rem', width:'100%', fontWeight:'normal'}} to={"#"} onClick={(e) => {onDeleteHoliday(2);}} className="btn-custom btn-primary">{t('calendar.series.thisAndFuture')}</Link>
          </div>
          <div>
            <Link style={{marginBottom:"0.5rem", display:"block", textAlign:"center", width:'100%', fontSize:'0.8rem', fontWeight:'normal'}} to={"#"} onClick={(e) => {onDeleteHoliday(3);}} className="btn-custom btn-primary">{t('calendar.series.thisOnly')}</Link>
          </div>
          </div>
        </div>
      </Modal>
    </div>
  </div>
  );
}